export default {
  'pages.memberList.create.title': '創建會員',
  'pages.memberList.exportCustomer': '匯出顧客',
  'pages.memberList.exportRetailCustomerTitle': '匯出普通顧客',
  'pages.memberList.firstName': '名字',
  'pages.memberList.firstName.required': '請輸入名字',
  'pages.memberList.middleName': '中間名',
  'pages.memberList.lastName': '姓氏',
  'pages.memberList.lastName.required': '請輸入姓氏',
  'pages.memberList.allowNameEdit': '允許自行修改姓名',
  'pages.memberList.allowNameEdit.help': '此權限用於區分普通顧客和 Staff & Trade Members。',
  'pages.memberList.phone': '電話號碼',
  'pages.memberList.phone.required': '請輸入電話號碼',
  'pages.memberList.phone.invalid': '請輸入有效的電話號碼',
  'pages.memberList.email': '郵箱',
  'pages.memberList.email.invalid': '請輸入有效的郵箱地址',
  'pages.memberList.email.maxLength': '郵箱長度不能超過255個字符',
  'pages.memberList.birthday': '生日',
  'pages.memberList.notes': '備註',
  'pages.memberList.level': '會員等級',
  'pages.memberList.level.required': '請選擇會員等級',
  'pages.memberList.level.discount': '折扣',
  'pages.memberList.customizeDiscount': '自訂折扣',
  'pages.memberList.customizeDiscount.required': '請輸入自訂折扣',
  'pages.memberList.customizeDiscount.invalid': '自訂折扣必須在 0 到 100 之間',
  'pages.memberList.status': '狀態',
  'pages.memberList.status.active': '啟用',
  'pages.memberList.status.inactive': '未啟用',
  'pages.memberList.create.success': '會員創建成功',
  'pages.memberList.headoffice.error': '無法獲取總部信息',
  'pages.memberList.level.fetch.error': '獲取會員等級失敗',
  'pages.memberList.total': '共',
  'pages.memberList.items': '條記錄',
  'pages.memberList.rewardEnabled': '啟用積分獎勵',
  'pages.memberList.hasExistingMemberId': '已有會員ID',
  'pages.memberList.existingMemberId': '會員ID',
  'pages.memberList.existingMemberId.required': '請輸入會員ID',
  'pages.memberList.existingMemberId.invalid': '請輸入有效的會員ID（允許字母和數字）',
  'pages.memberList.existingMemberId.maxLength': '會員ID最大長度為15位',
  'pages.memberList.existingMemberId.placeholder': '請輸入已存在的會員ID',
  'pages.memberList.cardNumber': '卡號',
  'pages.memberList.cardNumber.invalid': '最多 20 位字母或數字',
  'pages.memberList.cardNumber.placeholder': '選填，最多 20 位字母或數字',
  'pages.memberList.cardNumber.help': '可在 Enrich POS 中像會員 ID 一樣搜尋，總部內不能重複。清空即刪除卡號。',
  'pages.memberList.search.memberIdOrCard.placeholder': '輸入會員ID或卡號',
};
